import Icon from '../../components/Icon.vue'

Icon.register({"brands/pushed":{"width":432,"height":512,"paths":[{"d":"M407 111.9L308.5 102.9 322.5 69.5C332.9 46 311.7 29.1 293.8 32.5L22.5 76.9C7.4 79.6-3.5 95.2 1.1 113.5L106.2 461.8C112.7 483.1 142.9 486 153.9 468.8L189.2 388 424.4 156.7C440.8 139.9 428.7 113.8 407 111.9zM297.6 53.6C302.7 52.9 305.1 56.1 302.8 61L286 100.9 108.6 84.6 297.6 53.6zM22.7 107.9C19.6 102.8 23.7 97.9 28.8 98.8L277.5 121.5 180.6 352.2 22.7 107.9zM136 456.4C133.4 460.4 128.1 459.5 126.6 455.2L43.5 179.7 171.2 377.3C164.2 392.3 136 456.4 136 456.4zM408.8 141.9L210.1 337.3 299.8 123.6 406.2 133.3C410.2 134.4 411.9 138.6 408.8 141.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/pushed.js
// module id = Sczx
// module chunks = 0